import { SET_SCAN_CLAIM } from './types';

export const setScanClaim = (scanClaim) => ({
  type: SET_SCAN_CLAIM,
  payload: scanClaim,
});
